import React from 'react';
import {TableBody, TableContainer, TableHead, Button, Typography} from '@mui/material';

import {TagChip} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatPriceBill} from 'presentation/utils';

import {Card, StyledTable, StyledTableBodyRow, StyledTableHeadRow, StyledTableCell} from './styles';
import type {HistoryRow, HistoryTableProps} from './types';

const {status, value, reference, payment, viewDetails} =
	translations['pt-br'].privateFlow.myFinancial.paymentsHistory.historyTable;

function HistoryTable({rows, onViewDetails}: HistoryTableProps) {
	return (
		<Card>
			<TableContainer>
				<StyledTable>
					<TableHead>
						<StyledTableHeadRow>
							<StyledTableCell>{status}</StyledTableCell>
							<StyledTableCell>{value}</StyledTableCell>
							<StyledTableCell>{reference}</StyledTableCell>
							<StyledTableCell>{payment}</StyledTableCell>
							<StyledTableCell align="right" />
						</StyledTableHeadRow>
					</TableHead>
					<TableBody>
						{rows.map((row: HistoryRow) => (
							<StyledTableBodyRow key={row.id}>
								<StyledTableCell>
									<TagChip label="Pago" color="success" />
								</StyledTableCell>
								<StyledTableCell>
									<Typography variant="h6" fontWeight={600} component="span">
										{formatPriceBill(row.valor)}
									</Typography>
								</StyledTableCell>
								<StyledTableCell>{row.referencia}</StyledTableCell>
								<StyledTableCell>{row.pagamento}</StyledTableCell>
								<StyledTableCell align="right">
									<Button
										type="button"
										variant="outlined"
										size="small"
										sx={{borderRadius: 9999}}
										onClick={() => onViewDetails?.(row)}>
										{viewDetails}
									</Button>
								</StyledTableCell>
							</StyledTableBodyRow>
						))}
					</TableBody>
				</StyledTable>
			</TableContainer>
		</Card>
	);
}

export {HistoryTable};
